import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		gridTitleContainer: {
			justifyContent: ({ metaData }) => metaData.titleAlign?.contentAlignment(),
		},

		gridContainer: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(2),
		},

		container: {
			overflow: 'hidden',
		},

		item: {
			marginBottom: 2,

			[theme.breakpoints.up('sm')]: {
				padding: `${theme.spacing(1)} !important`,
			},
		},

		titleWrap: {
			display: 'flex',
			justifyContent: 'center',
			marginBottom: theme.spacing(5.6),
			textAlign: ({ metaData }) => metaData.titleAlign?.metaValue,
		},

		title: {
			textAlign: 'center',

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
	}),
	{ name: 'Category-Category7' },
)

export default useStyles
